import { Link, Typography } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import { useState } from 'react';

import ContactUsModal from 'components/Modal/modals/ContactUs';
import { Alert } from 'components';
import { Url } from 'utils/urls';

const InvalidPasswordError = ({
  resetPasswordHref
}: {
  resetPasswordHref?: string;
}) => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div style={{ margin: '10px 0' }}>
      <ContactUsModal
        open={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      <Alert
        variant="standard"
        severity="warning"
        title={t('PAGE_LOGIN_ERROR_TITLE')}
      >
        <div>
          <Trans i18nKey="INVALID_CREDENTIALS_ERROR_MESSAGE">
            <Typography component="span" variant="body2" />
            <Link
              href={resetPasswordHref || Url.resetPassword}
              variant="body2"
            />
            <Typography component="span" variant="body2" />
            <Link
              sx={{ cursor: 'pointer', display: 'contents' }}
              component="button"
              variant="body2"
              type="button"
              onClick={() => {
                setIsContactModalOpen(true);
              }}
            />
            <Typography />
          </Trans>
        </div>
      </Alert>
    </div>
  );
};

export default InvalidPasswordError;
